import { card as en_card } from "../en/card";

/** card — RU slice (75 keys). */
export const card: Record<keyof typeof en_card, string> = {
  card_toasts_region_label: "Уведомления",
  card_loading: "Загрузка…",
  card_load_failed: "Не удалось загрузить карточку. Потяни, чтобы обновить.",
  card_write_unavailable_try_again: "Что-то пошло не так — попробуй ещё раз.",
  card_action_share: "Поделиться карточкой",
  card_action_copy_link: "Скопировать ссылку",
  card_action_more: "Ещё",
  card_action_contact: "Контакт",
  card_action_coming_soon: "Скоро",
  card_action_link_copied: "Ссылка скопирована.",
  card_item_kind_phone_label: "Телефон",
  card_item_kind_email_label: "Email",
  card_item_kind_instagram_label: "Instagram",
  card_item_kind_tiktok_label: "TikTok",
  card_item_kind_linkedin_label: "LinkedIn",
  card_item_kind_x_label: "X",
  card_item_kind_youtube_label: "YouTube",
  card_item_kind_url_label: "Ссылка",
  card_editor_entry_label: "Редактировать карточку",
  card_no_items_placeholder:
    "Добавь контакт, соцсеть или ссылку, чтобы поделиться.",
  card_editor_phase_4_placeholder: "Редактор появится в 4-й фазе",
  card_retry: "Попробовать ещё раз",
  card_editor_save_button: "Сохранить",
  card_editor_cancel_button: "Отмена",
  card_editor_remove_button: "Удалить",
  card_editor_section_identity: "ПРОФИЛЬ",
  card_editor_section_style: "СТИЛЬ",
  card_editor_section_contact: "КОНТАКТЫ",
  card_editor_section_socials: "СОЦСЕТИ",
  card_editor_section_links: "ССЫЛКИ",
  card_editor_identity_display_name_label: "Отображаемое имя",
  card_editor_identity_bio_label: "О себе",
  card_editor_identity_avatar_label: "Аватар",
  card_editor_identity_avatar_change: "Изменить",
  card_editor_style_theme_label: "Тема",
  card_editor_add_contact_row: "+ Добавить контакт",
  card_editor_add_social_row: "+ Добавить соцсеть",
  card_editor_add_link_row: "+ Добавить ссылку",
  card_editor_add_picker_title_contact: "Добавить контакт",
  card_editor_add_picker_title_social: "Добавить соцсеть",
  card_items_cap_reached_hint:
    "Ты достиг лимита в 30 элементов. Удали один, чтобы добавить новый.",
  card_items_cap_reached: "Достигнут лимит элементов — не удалось сохранить.",
  card_save_failed_generic: "Не удалось сохранить карточку. Попробуй ещё раз.",
  card_link_not_allowed: "Эта ссылка недопустима в Linqx.",
  card_theme_picker_title: "Тема",
  card_theme_picker_badge_free: "Бесплатно",
  card_theme_picker_badge_premium: "Премиум",
  card_theme_picker_prev: "Предыдущая тема",
  card_theme_picker_next: "Следующая тема",
  card_theme_premium_locked: "Премиум-темы пока недоступны.",
  card_item_sheet_phone_label_header: "НОМЕР ТЕЛЕФОНА",
  card_item_sheet_email_label_header: "АДРЕС EMAIL",
  card_item_sheet_email_format_hint: "Формат: name@domain.com",
  card_item_sheet_label_label_header: "НАЗВАНИЕ",
  card_item_sheet_url_label_header: "URL",
  card_item_sheet_url_error: "URL должен начинаться с http:// или https://",
  card_item_sheet_label_counter: "{count} / 50",
  card_item_sheet_title_custom_link: "Своя ссылка",
  card_lite_explainer_text:
    "Контакты откроются после того, как вы встретитесь — отправь запрос на связь, чтобы поделиться контактами.",
  card_lite_request_to_connect: "Отправить запрос на связь",
  card_lite_request_sent: "Запрос отправлен",
  card_lite_request_sent_success:
    "Запрос отправлен — контакты откроются, как только вы оба подтвердите.",
  card_lite_cannot_connect_to_self:
    "Нельзя отправить запрос на связь самому себе.",
  card_unavailable_title: "Карточка недоступна",
  card_unavailable_message:
    "Эта карточка больше недоступна. Возможно, владелец удалил свой аккаунт.",
  card_unavailable_back_button: "Назад",
  card_share_action_label: "Поделиться карточкой",
  card_launcher_tab_title: "Моя карточка",
  card_launcher_tab_subtitle:
    "Твоя цифровая карточка контактов живёт в мини-приложении MyLinqx Card — открой её, чтобы посмотреть, отредактировать и поделиться.",
  card_launcher_tab_open_button: "Открыть MyLinqx Card",

  // MyLinqx Card — список связей + переход в чат с карточки
  connections_title: "Связи",
  connections_empty_heading: "Пока нет связей",
  connections_empty_body:
    "Люди появятся здесь, как только вы оба подтвердите встречу.",
  connections_message_button: "Написать {name}",
  connections_message_button_short: "Написать",
  connections_load_failed: "Не удалось загрузить связи. Попробуй ещё раз.",
};
